import { render, staticRenderFns } from "./CrowdfundingPage.vue?vue&type=template&id=4fa05494&scoped=true"
import script from "./CrowdfundingPage.vue?vue&type=script&lang=js"
export * from "./CrowdfundingPage.vue?vue&type=script&lang=js"
import style0 from "./CrowdfundingPage.vue?vue&type=style&index=0&id=4fa05494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa05494",
  null
  
)

export default component.exports